"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Basket_module_1 = require("./modules/Basket.module");
const WishList_module_1 = require("./modules/WishList.module");
const ShopTheLook = () => ({
    hasRouter: false,
    modules: [(0, Basket_module_1.default)(), (0, WishList_module_1.default)()],
});
exports.default = ShopTheLook;
